import { render, staticRenderFns } from "./Stock.vue?vue&type=template&id=5bd0e3ca&scoped=true"
import script from "./Stock.vue?vue&type=script&lang=js"
export * from "./Stock.vue?vue&type=script&lang=js"
import style0 from "./Stock.vue?vue&type=style&index=0&id=5bd0e3ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd0e3ca",
  null
  
)

export default component.exports